import { Matrix4, Quaternion, Vector3 } from '@technology/web3d';

/**
 * Computes the world-space point the center of the planar image maps to,
 * derived from the camera's projection and world matrices.
 *
 * NDC (0,0,1) is the center of the far plane. Unprojecting it through the
 * inverse projection matrix and then through matrixWorld gives the world
 * point that lies along the camera's principal ray at far-plane depth.
 */
export function computeCenterRayTarget(
  projectionMatrix: Matrix4,
  matrixWorld: Matrix4
): Vector3 {
  return new Vector3(0, 0, 1)
    .applyMatrix4(new Matrix4().copy(projectionMatrix).invert())
    .applyMatrix4(matrixWorld);
}

/**
 * Derives the frustum look-at quaternion for a planar image pane.
 *
 * centerRayTarget is already in world space (derived from the camera's
 * projection and world matrices), so a direct lookAt is sufficient.
 */
export function computePlanarLookAtQuaternion(
  cameraPosition: Vector3,
  centerRayTarget: Vector3
): Quaternion {
  const lookAtMatrix = new Matrix4().lookAt(
    cameraPosition,
    centerRayTarget,
    new Vector3(0, 0, 1)
  );
  return new Quaternion().setFromRotationMatrix(lookAtMatrix);
}
